import getStore from '../store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

export default function isAgendaMailOptionDirty(): boolean {
    const serverCalendarFolders = getStore().serverCalendarFolders;
    const agendaMailDisabledMap = getStore().agendaMailDisabledMap;
    const isAgendaMailEnabled = getStore().isAgendaMailEnabled;

    // 1. Check if the AgendaMailEnabled option is different from server
    const mailboxCalendarConfiguration = getCalendarConfiguration();
    if (
        mailboxCalendarConfiguration &&
        isAgendaMailEnabled != mailboxCalendarConfiguration.AgendaMailEnabled
    ) {
        return true;
    }

    // 2. Check if any calendar folder's AngendaMailDisabled option is different from server
    for (let i = 0; i < serverCalendarFolders.length; i++) {
        const serverCalendarFolder = serverCalendarFolders[i];
        if (
            agendaMailDisabledMap.get(serverCalendarFolder.FolderId.Id) !=
            serverCalendarFolder.AgendaMailDisabled
        ) {
            // Consider the agenda mail option is dirty as long as the local agendar mail disabled option(from the agendaMailDisabledMap) is different from the one from server
            return true;
        }
    }

    return false;
}
